<template>
  <v-card class="emoji-picker elevation-8">
    <div class="emoji-picker__header">
      <span class="emoji-picker__title">Emoticonos</span>
      <v-spacer></v-spacer>
      <v-btn icon small flat class="ma-0" @click="$emit('close')">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="emoji-picker__body">
      <div v-for="group in groups" :key="group.name" class="emoji-picker__group">
        <div class="emoji-picker__group-name">{{ group.name }}</div>
        <div class="emoji-picker__grid">
          <button
            v-for="emoji in group.emojis"
            :key="emoji"
            type="button"
            class="emoji-picker__emoji"
            :title="emoji"
            @mousedown.prevent
            @click="$emit('select', emoji)"
          >
            {{ emoji }}
          </button>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
// Selección corta de emoticonos de uso habitual en la relación asesor-cliente.
// Son caracteres Unicode: se guardan como texto en el mensaje (utf8mb4).
// Cada grupo es una cadena separada por espacios para que la lista sea legible.
const GROUPS = [
  {
    name: 'Caras',
    emojis: [
      '😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃',
      '😉 😌 😍 🥰 😘 😋 😎 🤓 🤔 🤗 🤩 🥳',
      '😐 😑 😶 🙄 😏 😬 😮 😲 😳 🥺 😢 😭',
      '😤 😠 😱 😴 🤒 😷',
    ]
      .join(' ')
      .split(' '),
  },
  {
    name: 'Gestos',
    emojis: ['👍 👎 👌 ✌️ 🤞 🤝 🙏 👏 🙌 👋 💪 ✍️', '👀 👉 👈 👆 👇 ☝️'].join(' ').split(' '),
  },
  {
    name: 'Trabajo',
    emojis: [
      '📄 📑 📁 📂 📎 📌 📅 📆 ⏰ ⌛ 📞 📧',
      '✉️ 📨 💼 🏢 🏦 💰 💶 💳 🧾 📊 📈 📉',
      '🖨️ 💻 🔒 🔑 ✏️ 📝',
    ]
      .join(' ')
      .split(' '),
  },
  {
    name: 'Símbolos',
    emojis: [
      '✅ ☑️ ✔️ ❌ ⚠️ ❗ ❓ ℹ️ 🔔 ⭐ 🌟 ✨',
      '🎉 🎊 🎁 ❤️ 💙 💚 💛 🧡 💜 🔥 💯 🚀',
      '☀️ 🌧️ 🎄 🍀 ☕ 🍾',
    ]
      .join(' ')
      .split(' '),
  },
];

export default {
  name: 'EmojiPicker',
  data() {
    return {
      groups: GROUPS,
    };
  },
};
</script>

<style scoped>
.emoji-picker {
  width: 330px;
}
.emoji-picker__header {
  display: flex;
  align-items: center;
  padding: 4px 4px 4px 12px;
  border-bottom: 1px solid #eee;
}
.emoji-picker__title {
  font-weight: 500;
}
.emoji-picker__body {
  max-height: 260px;
  overflow-y: auto;
  padding: 4px 8px 8px;
}
.emoji-picker__group-name {
  font-size: 12px;
  color: #757575;
  margin: 6px 0 2px;
}
.emoji-picker__grid {
  display: flex;
  flex-wrap: wrap;
}
.emoji-picker__emoji {
  width: 32px;
  height: 32px;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
}
.emoji-picker__emoji:hover,
.emoji-picker__emoji:focus {
  background-color: #eeeeee;
  outline: none;
}
</style>
